module.exports = __webpack_public_path__ + "static/media/nissan-logo.3f868059.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/nissan-logo.png
// module id = 7354
// module chunks = 4